import React from 'react';
import LocalizedStrings from 'react-localization';
import Widget from '../Widget/Widget.js';
import {ResponsiveContainer, PieChart, Pie, Tooltip, Legend, Cell, Label} from 'recharts';
import 'react-table/react-table.css'
import './SavedSearchPieChartWidget.css';

class SavedSearchPieChartWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       noData: 'No data available'
     },
     de: {
       noData: 'Keine Daten verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  renderTooltip() {
    if(this.props.displayTooltip) {
      return (<Tooltip wrapperStyle={{color:"black", backgroundColor:"#F5F5F5"}}/>)
    }
  }

  renderLegend() {
    if(this.props.displayLegend) {
      return (<Legend />);
    }
  }

  getTotal() {

    var total = 0

    for(var i = 0; i < this.props.search.rows.length; i++) {
      total += this.props.search.rows[i].value;
    }

    return total;
  }

  renderSegmentLabels(props) {
    if(this.props.displaySegmentLabels) {
      const totalHeight = (this.props.rowHeight*this.props.size.h);

      var labelPositions = this.getPieLabelPositions(props, 5);
      var fontSize = 25;

      if(totalHeight > 500) {
        fontSize = 40;
        labelPositions = this.getPieLabelPositions(props, 10);
      } else if(totalHeight > 450) {
        fontSize = 35;
        labelPositions = this.getPieLabelPositions(props, 8);
      } else if(totalHeight > 400) {
        fontSize = 30;
        labelPositions = this.getPieLabelPositions(props, 6);
      }

      return (<text x={labelPositions.x} y={labelPositions.y} fill={props.fill} fontSize={fontSize} textAnchor={props.textAnchor}>{props.value}</text>);
    }
  }

  getPieLabelPositions(props, offset) {
    var x = props.x;
    var y = props.y;

    if(props.textAnchor === "start") {
      x += offset

      if(y > props.cy) {
        y += (offset + 2)
      }

    } else if(props.textAnchor === "middle") {
      y -= offset
    } else if(props.textAnchor === "end") {
      x -= offset
      y += offset
    }

    return {
      x:x,
      y:y
    }
  }

  renderCentreLabel() {
    if(this.props.displayTotalInCentre) {

      const totalHeight = (this.props.rowHeight*this.props.size.h);
      var fontSize = 35;

      if(totalHeight > 500) {
        fontSize = 100;
      } else if(totalHeight > 450) {
        fontSize = 80;
      } else if(totalHeight > 400) {
        fontSize = 60;
      }

      return (<Label value={this.getTotal()} offset={0} position="center" fill={this.props.widgetTextColour} fontSize={fontSize}/>)
    }
  }

  renderPie() {

    const segments = this.props.search.rows.map((entry, index) => {
      if(this.props.pieColours && this.props.pieColours[entry.name]) {
        return (<Cell key={index+"_"+entry.name} fill={this.props.pieColours[entry.name]} stroke={this.props.pieColours[entry.name]}/>)
      }
      return(<Cell/>)
    });

    if(this.props.segmentStyle === 'Gauge') {

      var radius = "90%"
      var innerRadius = "65%";

      if(this.props.displaySegmentLabels) {
        radius = "65%"
        innerRadius = "45%";
      }


      return(<Pie data={this.props.search.rows}
                  dataKey="value"
                  fill="#8884d8"
                  paddingAngle={this.props.segmentSpacing}
                  outerRadius={radius}
                  innerRadius={innerRadius}
                  label={this.renderSegmentLabels.bind(this)}
                  labelLine={this.props.displaySegmentLabels}>
                  {segments}
                  {this.renderCentreLabel()}
             </Pie>)
    } else {

      return(<Pie data={this.props.search.rows}
                  dataKey="value"
                  fill="#8884d8"
                  paddingAngle={this.props.segmentSpacing}
                  label={this.renderSegmentLabels.bind(this)}>
                  {segments}
                  {this.renderCentreLabel}
             </Pie>)
    }
  }

  renderChart() {
    if(this.props.search && this.props.search.rows && this.props.search.rows.length > 0) {

      const height = (this.props.rowHeight*this.props.size.h) - 120;

      return (
            <ResponsiveContainer width="100%" height={height}>
              <PieChart height={height}>
                {this.renderPie()}
                {this.renderTooltip()}
                {this.renderLegend()}
              </PieChart>
            </ResponsiveContainer>
      )
    } else {
      return (<h2 className="text-center">{ this.strings.noData }</h2>);
    }
  }

  render() {
    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{this.props.title}</h1>
            {this.renderChart()}
          </div>
        </div>
      </Widget>
    )

  }
}

export default SavedSearchPieChartWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchPieChartWidget/SavedSearchPieChartWidget.js